export default "__VITE_ASSET__MmDrcEm9__"